export function extractApiList(payload) {
  if (!payload) return [];

  const root = payload?.data ?? payload;

  if (Array.isArray(root)) return root;
  if (Array.isArray(root?.items)) return root.items;
  if (Array.isArray(root?.docs)) return root.docs;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.docs)) return payload.docs;

  return [];
}

export function extractApiPagination(payload) {
  if (!payload) return null;

  const root = payload?.data ?? payload;
  return root?.pagination || payload?.pagination || null;
}
